import type { FC, ReactNode } from 'react';

interface RowProps {
  children: ReactNode;
}

export const Row: FC<RowProps> = ({ children }) => <div className="mb-5">{children}</div>;
